import { render } from "./dataSource.vue?vue&type=template&id=51d3637c&scoped=true"
import script from "./dataSource.vue?vue&type=script&lang=js"
export * from "./dataSource.vue?vue&type=script&lang=js"

import "./dataSource.vue?vue&type=style&index=0&id=51d3637c&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d3637c"]])

export default __exports__